import { createFileRoute, redirect } from "@tanstack/react-router";

// 301 redirect: legacy WordPress URL -> current canonical page
export const Route = createFileRoute("/web-design")({
  beforeLoad: () => {
    throw redirect({ href: "/services/website-design", statusCode: 301 });
  },
});
